import type { FC, ReactNode } from 'react'

import { Fragment } from 'react'
import { cn } from '@/lib/utils'
import { revealDelay } from '@/lib/motion'

interface HeroTitleProps {
    lines: ReactNode[]
    id?: string
    as?: 'h1' | 'h2'
    delay?: number
    step?: number
    className?: string
}

/*
 * Headline whose lines rise out of a mask one after another. Each entry in `lines` is one line on
 * every screen size, so keep lines short enough to sit on one or two rows on a phone.
 */
export const HeroTitle: FC<HeroTitleProps> = ({
    lines,
    id,
    as: Tag = 'h1',
    delay = 0,
    step = 90,
    className
}): ReactNode => {
    return (
        <Tag id={id} className={cn('font-heading', className)}>
            {lines.map((line, index) => (
                <Fragment key={index}>
                    {index > 0 && ' '}
                    <span className='reveal-mask'>
                        <span className='reveal-line' style={revealDelay(delay + index * step)}>
                            {line}
                        </span>
                    </span>
                </Fragment>
            ))}
        </Tag>
    )
}
